export default __webpack_public_path__ + "static/ios-case-1-3ef596859be19508976315f526b0674f.webp";